import { PadddingLeftRight16px } from '../../common/Padding';
import React from 'react';
import { MarginTop16px } from '../../common/Margin';
import Button, { buttonTypes } from '../../common/Button';
import { getString } from '../../../services/api/store';
import { SectionTitle } from '../style/index';
import ReactHtmlParser from 'react-html-parser';
import { SectionDescription } from '../../DetailPage/InfoBar';

const ProfileInformationContact = ({
    theme,
    profileData,
    showMore,
    readAll,
    setReadAll,
    text,
    renderRepresentativeOfList,
}) => {
    const TEXT_REPRESENTATIVE_ROLE = getString('representativeRole') || 'Representative of';

    return (
        <PadddingLeftRight16px>
            {profileData &&
                profileData.representativeOf &&
                profileData.representativeOf.length > 0 && (
                    <>
                        <SectionTitle>{TEXT_REPRESENTATIVE_ROLE}</SectionTitle>
                        {renderRepresentativeOfList()}
                    </>
                )}
            {profileData && profileData.headline && (
                <>
                    <SectionTitle>Biography</SectionTitle>
                    <SectionDescription primary={theme.primary} contrast={theme.contrast}>
                        {ReactHtmlParser(text)}
                    </SectionDescription>
                    <MarginTop16px />
                    {showMore && (
                        <Button
                            type={buttonTypes.GREY_LONG}
                            background={theme.primary}
                            text={
                                !readAll
                                    ? getString('announcementsReadMore') || 'Read More'
                                    : getString('announcementsReadLess') || 'Read less'
                            }
                            onClick={() => setReadAll(!readAll)}
                        />
                    )}
                </>
            )}
        </PadddingLeftRight16px>
    );
};

export default ProfileInformationContact;
